<template>

  <div class="-wrapper-column h-center- -height-100 -px-10 -py-10">
    <div class="login-logo-wrap -wrapper-v-center -width-100">
      <img src="/assets/images/logo_header.jpg" alt="Ops Now" />
    </div>
    <div class="login-cont-wrap -wrapper -wrapper-v-h-center">
      <div class="login-wrap s2 -wrapper nowrap-">
        
        <validation-observer v-slot="{invalid}" slim>
          <div class="form-wrap -wrapper h-center- -font-size-12">
            
            <h1 class="-h1 -mb-10 -font-size-32 -font-weight-medium">{{$t('pages_login_ResetPassword.1')}}</h1>

            <g-input-text-label class="-pb-8 -width-100" :label="$t('pages_login_ResetPassword.label.2')" star>
              <input type="password" style="width: 0;height: 0;position: absolute; visibility: hidden;" />
              <validation-provider
                tag="div"
                class="-wrapper"
                name="newPassword"
                :bails="false"
                rules="required|has_big_alpha|has_small_alpha|has_special_character|has_digit|minmax:8,30|password"
                v-slot="{failedRules, failed}">
                  <g-input-text 
                    type="text"
                    style="text-security:disc; -webkit-text-security:disc;" 
                    autocomplete="new-password" 
                    class="-width-100" 
                    :placeholder="$t('pages_login_ResetPassword.label.2')" :invalid="failed" v-model="newPassword">
                  </g-input-text>
                  <div class="-mt-0 text-left- -width-100">
                    <p class="-description-error" v-if="errorMessage">
                      {{errorMessage}}
                    </p>
                    <template v-if="newPassword.length > 0">
                      <div class="-wrapper -mt-1">
                        <div class="-wrapper-v-center -font-size-12 -color-gray-1"><g-icon :name="faildRulesIcon(failedRules.has_big_alpha)" size="medium" />영문 대문자</div>
                        <div class="-wrapper-v-center -font-size-12 -color-gray-1"><g-icon :name="faildRulesIcon(failedRules.has_small_alpha)" size="medium" />영문 소문자</div>
                        <div class="-wrapper-v-center -font-size-12 -color-gray-1"><g-icon :name="faildRulesIcon(failedRules.has_special_character || failedRules.password)" size="medium" />특수문자</div>
                        <div class="-wrapper-v-center -font-size-12 -color-gray-1"><g-icon :name="faildRulesIcon(failedRules.has_digit)" size="medium" />숫자</div>
                        <div class="-wrapper-v-center -font-size-12 -color-gray-1"><g-icon :name="faildRulesIcon(failedRules.minmax)" size="medium" />8~30자</div>
                      </div>
                    </template>
                  </div>
              </validation-provider>
            </g-input-text-label>
            <validation-provider
              tag="div"
              class="-width-100"
              name="newPasswordConfirm"
              rules="required|equal:@newPassword"
              v-slot="{failed}"
              >
                <g-input-text-label :label="$t('pages_login_ResetPassword.label.3')" star class="-pb-4 -width-100">
                    <g-input-text 
                      type="text"
                      style="text-security:disc; -webkit-text-security:disc;" 
                      autocomplete="new-password" 
                      class="-width-100" 
                      :placeholder="$t('pages_login_ResetPassword.label.3')" 
                      :invalid="failed" 
                      v-model="newPasswordConfirm">
                    </g-input-text>
                </g-input-text-label>
              </validation-provider>

              <div class="-border -p-4 -width-100">
                <p class="-description" >
                  {{$t('pages_login_ResetPassword.label.desc.1')}}
                  <br>
                  {{$t('pages_login_ResetPassword.label.desc.2')}}
                  <!--
                  <br>
                  {{$t('pages_login_ResetPassword.label.desc.3')}}
                  -->
                </p>
              </div>
            <div class="-label -wrapper h-center- -width-100 -mt-8">
              <g-button variant="secondary" @click="onClickCancel">
                <span>{{$t('common.cancel')}}</span>
              </g-button><!--
              --><g-button variant="primary" @click="onClickSubmit" :disabled="invalid">
                <span>{{$t('common.ok')}}</span>
              </g-button>
            </div>

            <div class="-wrapper-column -width-100 -mt-8 -pt-8 -pb-4 v-h-center- -border-top">
              <!--
              <h3 class="-wrapper-h-center -width-100 -h3 -font-weight-regular">
                {{$t('pages_login_ResetPassword.label.inquiry.1')}}
              </h3>
              -->
              <g-button variant="secondary" class="-mt-5" @click="onInquery">
                <span>{{$t('pages_login_ResetPassword.label.inquiry.2')}}</span>
              </g-button>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import CodeCreate from '@/code/CodeCreate'

export default {
  name: 'reset-password',
  componentName: 'ResetPassword',
  components: {ValidationProvider, ValidationObserver},
  computed: {
    ...mapGetters('user', ['userInfo', 'codeUserCreate', 'codeChangePassword', 'userErrorMessage']),
    faildRulesIcon: () => (hasRule) => {
      if (hasRule) {
        return 'ci-icon-check-error'
      } else {
        return 'ci-icon-check'
      }
    },
    userEmail: () => {
      return this.userInfo.userEmail
    }
  },
  data() {
    return {
      resetError: false,
      newPassword: '',
      newPasswordConfirm: '',
      errorMessage: ''
    }
  },
  watch: {
    codeChangePassword: {
      handler () {
        if (this.codeChangePassword === CodeCreate.ERROR) {
          this.errorMessage = this.$t(this.userErrorMessage)
        } else if (this.codeChangePassword === CodeCreate.SUCCESS) {
          this.$router.push('/home')
        }
      },
      deep: true
    },
    newPassword: {
      handler () {
        this.errorMessage = ''
      }
    }
  },
  methods: {
    ...mapActions('user', ['updateFirstPassword']),
    onClickCancel () {
      window.keycloak.logout()
    },
    onClickSubmit () {
      this.updateFirstPassword({
        newPassword: this.newPassword,
        newPasswordConfirm: this.newPasswordConfirm
      })
    },
    onInquery(){
      let a = document.createElement('a')
      a.target = "_blank"
      a.href = `mailto:cheng.li@bespinglobal.com?cc=donghun.cho@bespinglobal.com&subject=` + this.$t('pages_login_ResetPassword.label.inquiry.title')
      document.body.appendChild(a)
      a.onclick = function(e) {
        setTimeout(() => {
          resolve()
        }, 1000)
        document.body.removeChild(a)
      }
      a.click()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/login/ResetPassword.vue